import { Suspense } from 'react'

import { Outlet } from 'react-router'

import { ActionItemsProvider } from '@tribeplatform/react-components/ActionItems'
import {
  CommandBar,
  CommandBarProvider,
} from '@tribeplatform/react-components/CommandBar'
import { FirstRenderProvider } from '@tribeplatform/react-components/common/ssr'
import { QueryLayoutProvider } from '@tribeplatform/react-components/LayoutFrame'
import { ModalProvider } from '@tribeplatform/react-components/Modal'
import { AppProvider } from '@tribeplatform/react-ui-kit/AppProvider'

import { TrialExpiredGate } from './client/components/Admin/Billing/TrialExpiredGate.js'
import { DesktopNotificationProvider } from './client/providers/notification/DesktopNotificationProvider.js'
import { SegmentProvider } from './client/providers/SegmentProvider.js'
import { TribeWeb } from './client/TribeWeb.js'
import { useGuard } from './client/useGuard.js'
import { InjectedAppProps } from './server/types/server.types.js'

export function RootRoute({
  injectedAppProps,
}: {
  injectedAppProps: InjectedAppProps
}) {
  useGuard({ injectedAppProps })

  return (
    <AppProvider>
      <SegmentProvider>
        <TribeWeb otsm={injectedAppProps.otsm}>
          <QueryLayoutProvider>
            <FirstRenderProvider>
              <ModalProvider>
                <ActionItemsProvider>
                  <CommandBarProvider>
                    <Suspense fallback={<></>}>
                      <CommandBar />
                    </Suspense>
                    <DesktopNotificationProvider>
                      <TrialExpiredGate>
                        <Suspense fallback={<></>}>
                          <Outlet />
                        </Suspense>
                      </TrialExpiredGate>
                    </DesktopNotificationProvider>
                  </CommandBarProvider>
                </ActionItemsProvider>
              </ModalProvider>
            </FirstRenderProvider>
          </QueryLayoutProvider>
        </TribeWeb>
      </SegmentProvider>
    </AppProvider>
  )
}
